// import React, { useEffect, useState } from "react";

// // region import from local file
// // import closeIcon from '../../../assets/images/Sidebar/close-menu.png';
// import closeIcon from '../../../assets/images/Sidebar/collapseImg.svg';
// // import openIcon from '../../../assets/images/Sidebar/open-menu.png';
// import openIcon from '../../../assets/images/Sidebar/openImg.svg';
// import companyLogo from '../../../assets/images/Sidebar/company-logo.svg';
// import companySmallLogo from '../../../assets/images/Sidebar/company-small-logo.svg';
// import dashboard from '../../../assets/images/Sidebar/dashboard.svg';
// import chevronUpImg from '../../../assets/images/Dashboard/chevron-down.svg';
// import customerManagement from '../../../assets/images/Sidebar/customer-management.svg';
// import userManagement from '../../../assets/images/Sidebar/user-management.svg';
// import attendanceLeaves from '../../../assets/images/Sidebar/attendance-leaves.svg';
// import complaintEscalation from '../../../assets/images/Sidebar/complaint-escalation.svg';
// import serviceLevelAgreement from '../../../assets/images/Sidebar/service-level-agreement.svg';
// import workQueues from '../../../assets/images/Sidebar/work-queues.svg';
// import systemLogging from '../../../assets/images/Sidebar/system-logging.svg';
// import { useLocation, useNavigate } from "react-router-dom";
// // endregion

// export default function SideBar({ setClick, click }) {
//     const handleClick = () => setClick(!click);

//     const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
//     const AssignedModules = JSON.parse(sessionStorage.getItem('AssignedModules'));
//     console.log(AssignedModules,'AssignedModules')
//     const [systemLoggingOpen, setSystemLoggingOpen] = useState(false);
//     const [activeMenu, setActiveMenu] = useState('/dashboard');

//     const navigate = useNavigate()
//     const location = useLocation(); // Use useLocation to track route changes

//     useEffect(() => {
//         // Update activeMenu based on current route
//         setActiveMenu(location.pathname);
//     }, [location.pathname]);

//     const handleNavigation = (path) => {
//         setActiveMenu(path);
//         navigate(path);
//     }

//     return (
//         <div className="lm-sidevar">
//             <div className={`container ${click ? "clicked" : ""}`} style={{ width: click ? "18.5vw" : "6vw" }}>
//                 <button className={`button ${click ? "clicked" : ""}`} onClick={handleClick}>
//                     <img src={click ? closeIcon : openIcon} alt="open-close" />
//                 </button>
//                 <div className="sidebar-container">
//                     {/* <div style={{ width: "100%" }}>
//                         <img
//                             src={click ? companyLogo : companySmallLogo}
//                             alt="Company Logo"
//                             className={click ? 'company-logo' : 'company-small-logo'}
//                         />
//                     </div> */}
//                     <div style={{ width: "100%" }}>
//                         <img
//                             src={companyLogo}
//                             alt="Company Logo"
//                             className={`company-logo ${click ? "clicked" : ""}`}
//                         />
//                         <img
//                             src={companySmallLogo}
//                             alt="Company Small Logo"
//                             className={`company-small-logo ${click ? "clicked" : ""}`}
//                         />
//                     </div>

//                     <ul className={`slick-bar ${click ? "clicked" : ""}`}>
//                         <li
//                             // className="item pt-4" 
//                             className={`item pt-4 ${activeMenu === "/dashboard" ? "clicked" : ""}`}
//                             onClick={() => handleNavigation("/dashboard")}>
//                             <img src={dashboard} alt="" />
//                             <span className={`text ${click ? "clicked" : ""}`}>Dashboard</span>
//                         </li>
//                         {signInDetails[0].SignInType !== "ClientAdmin" && signInDetails[0].SignInType !== "User" && <li
//                             // className="item" 
//                             className={`item ${activeMenu === "/customermanagement" ? "clicked" : ""}`}
//                             onClick={() => handleNavigation("/customermanagement")}>
//                             <img src={customerManagement} alt="" />
//                             <span className={`text ${click ? "clicked" : ""}`}>Customer Management</span>
//                         </li>}
//                         {signInDetails[0].SignInType !== "User" && <li
//                             // className="item" 
//                             className={`item ${activeMenu === "/usermanagement" ? "clicked" : ""}`}
//                             onClick={() => { handleNavigation("/usermanagement") }}>
//                             <img src={userManagement} alt="" />
//                             <span className={`text ${click ? "clicked" : ""}`}>User Management</span>
//                         </li>}
//                         <li
//                             // className="item" 
//                             className={`item ${activeMenu === "/leaves" ? "clicked" : ""}`}
//                             onClick={() => { handleNavigation("/leaves") }}>
//                             <img src={attendanceLeaves} alt="" />
//                             <span className={`text ${click ? "clicked" : ""}`}>Leave & Holiday</span>
//                         </li>
//                         <li
//                             // className="item" 
//                             className={`item ${activeMenu === "/complaint" ? "clicked" : ""}`}
//                             onClick={() => { handleNavigation("/complaint") }}>
//                             <img src={complaintEscalation} alt="" />
//                             <span className={`text ${click ? "clicked" : ""}`}>Complaint / Escalation</span>
//                         </li>
//                         <li
//                             // className="item"
//                             className={`item ${activeMenu === "/sla" ? "clicked" : ""}`}
//                             onClick={() => { handleNavigation("/sla") }}>
//                             <img src={serviceLevelAgreement} alt="" />
//                             <span className={`text ${click ? "clicked" : ""}`}>Service Level Agreement</span>
//                         </li>
//                         <li
//                             // className="item" 
//                             className={`item ${activeMenu === "/workqueues" ? "clicked" : ""}`}
//                             onClick={() => { handleNavigation("/workqueues") }}>
//                             <img src={workQueues} alt="" />
//                             <span className={`text ${click ? "clicked" : ""}`}>Work Queues</span>
//                         </li>
//                         <li
//                             // className="item"
//                             // className={`item ${systemLoggingOpen ? "open" : ""}`} onClick={() => setSystemLoggingOpen(!systemLoggingOpen)}
//                             className={`item ${systemLoggingOpen ? "open" : ""} ${activeMenu === "/systemlogging" ? "clicked" : ""}`}
//                             onClick={() => setSystemLoggingOpen(!systemLoggingOpen)}
//                         >
//                             <img src={systemLogging} alt="" />
//                             <span className={`text ${click ? "clicked" : ""}`}>System Logging</span>
//                             <img src={chevronUpImg} alt="" className={systemLoggingOpen ? "sidebar-chevron-down" : "sidebar-chevron-right"} />
//                         </li>
//                         {systemLoggingOpen && (
//                             <ul className="sub-menu">
//                                 <li
//                                     // className="sub-item pt-2 pb-2"
//                                     className={`sub-item pt-2 pb-2 ${activeMenu === "/audit-trial" ? "clicked" : ""}`}
//                                     onClick={() => handleNavigation("/audit-trial")}>
//                                     <img src={serviceLevelAgreement} alt="" />
//                                     <span className={`text ${click ? "clicked" : ""}`}>Audit Trial</span>
//                                 </li>
//                                 <li
//                                     //  className="sub-item pt-2 pb-2" 
//                                     className={`sub-item pt-2 pb-2 ${activeMenu === "/exception-log" ? "clicked" : ""}`}
//                                     onClick={() => handleNavigation("/exception-log")}>
//                                     <img src={serviceLevelAgreement} alt="" />
//                                     <span className={`text ${click ? "clicked" : ""}`}>Exception Log</span>
//                                 </li>
//                                 <li
//                                     // className="sub-item pt-2 pb-2"
//                                     className={`sub-item pt-2 pb-2 ${activeMenu === "/integration-log" ? "clicked" : ""}`}
//                                     onClick={() => handleNavigation("/integration-log")}>
//                                     <img src={serviceLevelAgreement} alt="" />
//                                     <span className={`text ${click ? "clicked" : ""}`}>Integration Log</span>
//                                 </li>
//                             </ul>
//                         )}
//                     </ul>
//                 </div>
//             </div>
//         </div>
//     );
// }



// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";

// // Import icons and assets
// import closeIcon from "../../../assets/images/Sidebar/collapseImg.svg";
// import openIcon from "../../../assets/images/Sidebar/openImg.svg";
// import companyLogo from "../../../assets/images/Sidebar/company-logo.svg";
// import companySmallLogo from "../../../assets/images/Sidebar/company-small-logo.svg";
// import chevronUpImg from "../../../assets/images/Dashboard/chevron-down.svg";
// import { useDispatch, useSelector } from "react-redux";
// import { loadRoleBasedModulePermissionsData } from "../../../redux/action";

// export default function SideBar({ setClick, click }) {
//     const [activeMenu, setActiveMenu] = useState("/dashboard");
//     const [openSubMenus, setOpenSubMenus] = useState({}); // Track open submenus

//     const navigate = useNavigate();
//     const location = useLocation();
//     let dispatch = useDispatch();
//     const { modulePermissions } = useSelector((state) => state.data);

//     useEffect(() => {
//         dispatch(loadRoleBasedModulePermissionsData());
//     }, []);

//     const handleNavigation = (path) => {
//         setActiveMenu(path);
//         navigate(path);
//     };

//     const handleClick = () => setClick(!click);

//     const handleSubMenuToggle = (moduleId) => {
//         setOpenSubMenus((prev) => ({
//             ...prev,
//             [moduleId]: !prev[moduleId], // Toggle submenu for specific module
//         }));
//     };

//     useEffect(() => {
//         // Update activeMenu when the location changes
//         setActiveMenu(location.pathname);
//     }, [location.pathname]);

//     return (
//         <div className="lm-sidevar">
//             <div className={`container ${click ? "clicked" : ""}`} style={{ width: click ? "18.5vw" : "6vw" }}>
//                 <button className={`button ${click ? "clicked" : ""}`} onClick={handleClick}>
//                     <img src={click ? closeIcon : openIcon} alt="toggle-menu" />
//                 </button>
//                 <div className="sidebar-container">
//                     <div style={{ width: "100%" }}>
//                         <img
//                             src={companyLogo}
//                             alt="Company Logo"
//                             className={`company-logo ${click ? "clicked" : ""}`}
//                         />
//                         <img
//                             src={companySmallLogo}
//                             alt="Company Small Logo"
//                             className={`company-small-logo ${click ? "clicked" : ""}`}
//                         />
//                     </div>
//                     <ul className={`slick-bar ${click ? "clicked" : ""}`}>
//                         {modulePermissions.map((module) => (
//                             <React.Fragment key={module.Modules_IDPK}>
//                                 <li
//                                     className={`item ${activeMenu === module.ModuleNavigationUrl ? "clicked" : ""}`}
//                                     onClick={() => {
//                                         if (module.ModuleNavigationUrl) {
//                                             handleNavigation(module.ModuleNavigationUrl); // Navigate if URL exists
//                                         } else if (module.SubModules && module.SubModules.length) {
//                                             handleSubMenuToggle(module.Modules_IDPK); // Toggle submenu
//                                         }
//                                     }}
//                                 >
//                                     <img src={module.ModuleIconPath} alt={module.Modules_Name} />
//                                     <span className={`text ${click ? "clicked" : ""}`}>{module.Modules_Name}</span>
//                                     {module.SubModules && module.SubModules.length > 0 && (
//                                         <img
//                                             src={chevronUpImg}
//                                             alt="toggle-submenu"
//                                             className={openSubMenus[module.Modules_IDPK] ? "sidebar-chevron-down" : "sidebar-chevron-right"}
//                                             onClick={(e) => {
//                                                 e.stopPropagation(); // Prevent event bubbling to parent `li`
//                                                 handleSubMenuToggle(module.Modules_IDPK);
//                                             }}
//                                         />
//                                     )}
//                                 </li>
//                                 {module.SubModules && openSubMenus[module.Modules_IDPK] && (
//                                     <ul className="sub-menu">
//                                         {module.SubModules.map((subModule) => (
//                                             <li
//                                                 key={subModule.SubModuleID}
//                                                 className={`sub-item pt-2 pb-2 ${activeMenu === subModule.SubModuleNavigationUrl ? "clicked" : ""}`}
//                                                 onClick={(e) => {
//                                                     e.stopPropagation(); // Prevent bubbling
//                                                     handleNavigation(subModule.SubModuleNavigationUrl);
//                                                 }}
//                                             >
//                                                 <img src={subModule.SubModuleIconPath || module.ModuleIconPath} alt={subModule.SubModuleName} />
//                                                 <span className={`text ${click ? "clicked" : ""}`}>{subModule.SubModuleName}</span>
//                                             </li>
//                                         ))}
//                                     </ul>
//                                 )}
//                             </React.Fragment>
//                         ))}
//                     </ul>
//                 </div>
//             </div>
//         </div>
//     );
// }





// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";

// // Import icons and assets
// import closeIcon from "../../../assets/images/Sidebar/collapseImg.svg";
// import openIcon from "../../../assets/images/Sidebar/openImg.svg";
// import companyLogo from "../../../assets/images/Sidebar/company-logo1.svg";
// import companySmallLogo from "../../../assets/images/Sidebar/company-small-logo.svg";
// import chevronUpImg from "../../../assets/images/Dashboard/chevron-down.svg";
// import { useDispatch, useSelector } from "react-redux";
// import { loadRoleBasedModulePermissionsData } from "../../../redux/action";
// import dashboard from '../../../assets/images/Sidebar/dashboard.svg';
// import workQueueMainMenuIcon from '../../../assets/images/Sidebar/workqueue-main-menu-icon.svg';
// import masterDataIcon from '../../../assets/images/Sidebar/masterData-icon.svg';
// import performanceManagementIcon from '../../../assets/images/Sidebar/performance-management-icon.svg';
// import warehouseManagementIcon from '../../../assets/images/Sidebar/warehouse-management-icon.svg';
// import systemManagementIcon from '../../../assets/images/Sidebar/system-management-icon.svg';

// export default function SideBar({ setClick, click }) {
//     const [activeMenu, setActiveMenu] = useState("/dashboard");
//     const [openSubMenus, setOpenSubMenus] = useState({}); // Track open submenus

//     const navigate = useNavigate();
//     const location = useLocation();
//     let dispatch = useDispatch();
//     const { modulePermissions = [] } = useSelector((state) => state.data);
//     console.log(modulePermissions, 'modulePermissions')
//     // const [modulePermissions, setModulePermissions] = useState([]);

//     useEffect(() => {
//         dispatch(loadRoleBasedModulePermissionsData());
//     }, []);

//     // Check sessionStorage for module permissions data
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     const storedModulePermissions = JSON.parse(sessionStorage.getItem("modulePermissions")) || [];

//     // useEffect(() => {
//     //     // Only set the state if the sessionStorage data is not empty and it's not already loaded in state
//     //     if (storedModulePermissions.length > 0 && modulePermissions.length === 0) {
//     //         setModulePermissions(storedModulePermissions); // Set module permissions only if not already set
//     //     } else if (storedModulePermissions.length === 0) {
//     //         // If sessionStorage is empty, dispatch action to fetch permissions
//     //         dispatch(loadRoleBasedModulePermissionsData());
//     //     }
//     // }, [storedModulePermissions, dispatch, modulePermissions]);

//     const handleNavigation = (path, moduleId = null) => {
//         if (moduleId) {
//             navigate(path, { state: { moduleId } });
//         } else {
//             navigate(path);
//         }
//         setActiveMenu(path);
//     };

//     const handleClick = () => setClick(!click);

//     const handleSubMenuToggle = (moduleId) => {
//         setOpenSubMenus((prev) => ({
//             ...prev,
//             [moduleId]: !prev[moduleId], // Toggle submenu for specific module
//         }));
//     };

//     const handleDashboardClick = () => {
//         const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

//         const dashboardLink = signInDetails?.[0]?.DashboardPublicLink;
//         const dashboardId = signInDetails?.[0]?.DashboardLibraryID;
//         const dashboardCategoryId = signInDetails?.[0]?.DashboardCategoryID;
//         const linkType = signInDetails?.[0]?.LinkType;

//         if (dashboardId && dashboardCategoryId !== 1) {
//             navigate(`/powerbi-dashboard/${dashboardId}`, {
//                 state: { viewType: linkType?.toLowerCase() },
//             });
//         } else if (dashboardCategoryId === 1 && dashboardLink) {
//             window.location.href = dashboardLink;
//         } else {
//             navigate('/');
//         }
//     };

//     useEffect(() => {
//         // Update activeMenu when the location changes
//         setActiveMenu(location.pathname);
//     }, [location.pathname]);

//     return (
//         <div className="sidebar-container">
//             <div className="sidebar-first-div">
//                 <div className="sidebar-first-div-icons">
//                     <img src={companySmallLogo} alt="Company Small Logo" className="company-small-logo" />
//                     {/* Dynamically render icons from modulePermissions */}
//                     {modulePermissions?.map((module) => (
//                         <img
//                             key={module.Modules_IDPK}
//                             src={module.SideBarMenuIcon}
//                             alt={module.Modules_Name + " Icon"}
//                             className="company-small-logo"
//                         />
//                     ))}
//                 </div>
//             </div>
//             <div className="lm-sidevar">
//                 <div className={`container ${click ? "clicked" : ""}`} style={{ width: click ? "19.5vw" : "6vw" }}>
//                     <button className={`button ${click ? "clicked" : ""}`} onClick={handleClick}>
//                         <img src={click ? closeIcon : openIcon} alt="toggle-menu" />
//                     </button>
//                     <div className="sidebar-container">
//                         <div style={{ width: "100%" }}>
//                             <img
//                                 src={companyLogo}
//                                 alt="Company Logo"
//                                 className={`company-logo ${click ? "clicked" : ""}`}
//                             />
//                             <img
//                                 src={companySmallLogo}
//                                 alt="Company Small Logo"
//                                 className={`company-small-logo ${click ? "clicked" : ""}`}
//                             />
//                         </div>
//                         <ul className={`slick-bar ${click ? "clicked" : ""}`}>
//                             {modulePermissions?.map((module) => (
//                                 <React.Fragment key={module.Modules_IDPK}>
//                                     {module.Modules_Name === "Dashboard" ? (
//                                         <li
//                                             className={`item ${activeMenu === module.ModuleNavigationUrl ? "clicked" : ""}`}
//                                             onClick={handleDashboardClick}
//                                         >
//                                             <img src={module.ModuleIconPath} alt={module.Modules_Name} />
//                                             <span className={`text ${click ? "clicked" : ""}`}>{module.Modules_Name}</span>
//                                         </li>
//                                     ) : (
//                                         // <React.Fragment key={module.Modules_IDPK}>
//                                         <li
//                                             className={`item ${activeMenu === module.ModuleNavigationUrl ? "clicked" : ""}`}
//                                             onClick={() => {
//                                                 if (module.ModuleNavigationUrl) {
//                                                     handleNavigation(module.ModuleNavigationUrl, module.Modules_IDPK); // Navigate with module ID
//                                                 } else if (module.SubModules && module.SubModules.length) {
//                                                     handleSubMenuToggle(module.Modules_IDPK); // Toggle submenu
//                                                 }
//                                             }}
//                                         >
//                                             <img src={module.ModuleIconPath} alt={module.Modules_Name} />
//                                             <span className={`text ${click ? "clicked" : ""}`}>{module.Modules_Name}</span>
//                                             {module.SubModules && module.SubModules.length > 0 && (
//                                                 <img
//                                                     src={chevronUpImg}
//                                                     alt="toggle-submenu"
//                                                     className={openSubMenus[module.Modules_IDPK] ? "sidebar-chevron-down" : "sidebar-chevron-right"}
//                                                     onClick={(e) => {
//                                                         e.stopPropagation(); // Prevent event bubbling to parent `li`
//                                                         handleSubMenuToggle(module.Modules_IDPK);
//                                                     }}
//                                                 />
//                                             )}
//                                         </li>
//                                     )}
//                                     {module.SubModules && openSubMenus[module.Modules_IDPK] && (
//                                         <ul className="sub-menu">
//                                             {module.SubModules.map((subModule) => (
//                                                 <li
//                                                     key={subModule.SubModuleID}
//                                                     className={`sub-item pt-2 pb-2 ${activeMenu === subModule.SubModuleNavigationUrl ? "clicked" : ""}`}
//                                                     onClick={(e) => {
//                                                         e.stopPropagation(); // Prevent bubbling
//                                                         handleNavigation(subModule.SubModuleNavigationUrl, subModule.SubModuleID); // Send SubModule ID
//                                                     }}
//                                                 >
//                                                     <img src={subModule.SubModuleIconPath || module.ModuleIconPath} alt={subModule.SubModuleName} />
//                                                     <span className={`text ${click ? "clicked" : ""}`}>{subModule.SubModuleName}</span>
//                                                 </li>
//                                             ))}
//                                         </ul>
//                                     )}
//                                 </React.Fragment >
//                             ))}
//                         </ul>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }



import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import closeIcon from "../../../assets/images/Sidebar/collapseImg.svg";
import openIcon from "../../../assets/images/Sidebar/openImg.png";
import companyLogo from "../../../assets/images/Sidebar/company-logo1.svg";
import companySmallLogo from "../../../assets/images/Sidebar/company-small-logo.svg";
import chevronDownImg from "../../../assets/images/Dashboard/chevron-down.svg";
import { loadCustomviews, loadRoleBasedModulePermissionsData } from "../../../redux/action";
import serviceLevelAgreement from '../../../assets/images/Sidebar/service-level-agreement.svg';

export default function SideBar({ setClick, click }) {
    const [activeMenu, setActiveMenu] = useState("/dashboard");
    const [openSubMenus, setOpenSubMenus] = useState({});
    const [selectedSidebarMenuId, setSelectedSidebarMenuId] = useState(null);

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { modulePermissions = [] } = useSelector((state) => state.data);
    const liRef = useRef({});
    const divRef = useRef(null);
    const sideBarRef = useRef(null);
    const [position, setPosition] = useState("");

    useEffect(() => {
        dispatch(loadRoleBasedModulePermissionsData());
    }, []);

    useEffect(() => {
        setActiveMenu(location.pathname);
    }, [location.pathname]);

    const handleToggleSidebar = () => setClick(!click);

    const handleNavigation = (url, id = null) => {
        if (id) {
            navigate(url, { state: { moduleId: id } });
        } else {
            navigate(url);
        }
        setActiveMenu(url);
    };

    const handleSidebarIconClick = (menuId) => {
        sessionStorage.setItem("SelectedSidebarMenuID", menuId);
        setSelectedSidebarMenuId(menuId);
        // setOpenSubMenus({});
    };

    useEffect(() => {
        const storedMenuId = parseInt(sessionStorage.getItem("SelectedSidebarMenuID"));
        if (storedMenuId) {
            setSelectedSidebarMenuId(storedMenuId);
        } else {
            setSelectedSidebarMenuId(null);
        }
    }, []);

    // const handleSubMenuToggle = (moduleId) => {
    //     setOpenSubMenus((prev) => ({
    //         ...prev,
    //         [moduleId]: !prev[moduleId],
    //     }));
    // };

    const handleSubMenuToggle = (moduleId) => {
        setOpenSubMenus((prev) => {
            // Close the previously opened sub-menu and open the clicked one
            const newSubMenus = { ...prev };
            if (newSubMenus[moduleId]) {
                // If the menu is already open, close it
                delete newSubMenus[moduleId];
            } else {
                // Otherwise, open it and close all other menus
                Object.keys(newSubMenus).forEach(key => delete newSubMenus[key]);
                newSubMenus[moduleId] = true;
            }
            return newSubMenus;
        });
        setTimeout(() => checkPosition(moduleId), 0)
    };

    // const handleDashboardClick = () => {
    //     const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails')) || [];
    //     const dashboardLink = signInDetails?.[0]?.DashboardPublicLink;
    //     const dashboardId = signInDetails?.[0]?.DashboardLibraryID;
    //     const dashboardCategoryId = signInDetails?.[0]?.DashboardCategoryID;
    //     const linkType = signInDetails?.[0]?.LinkType;

    //     if (dashboardId && dashboardCategoryId !== 1) {
    //         navigate(`/powerbi-dashboard/${dashboardId}`, {
    //             state: { viewType: linkType?.toLowerCase() },
    //         });
    //     } else if (dashboardCategoryId === 1 && dashboardLink) {
    //         window.location.href = dashboardLink;
    //     } else {
    //         navigate('/');
    //     }
    // };

    const handleDashboardClick = () => {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails')) || [];
        const signInType = signInDetails ? signInDetails[0].SignInType : null;

        const dashboardLink = signInDetails?.[0]?.DashboardPublicLink;
        const dashboardId = signInDetails?.[0]?.DashboardLibraryID;
        const dashboardCategoryId = signInDetails?.[0]?.DashboardCategoryID;
        const linkType = signInDetails?.[0]?.LinkType;
        const DefaultDashboardType = signInDetails?.[0]?.DefaultDashboardType;
        const CustomViewLink = signInDetails?.[0]?.CustomViewLink;
        const signInId =
            signInType === "SuperAdmin"
                ? signInDetails?.[0]?.SuperAdminID
                : signInType === "ClientAdmin"
                    ? signInDetails?.[0]?.CompanyID
                    : signInDetails?.[0]?.UserID;


        const getModuleID = () => {
            if (CustomViewLink === "/dashboard") return 2;
            if (CustomViewLink === "/licenceDashboard") return 3;
            if (CustomViewLink === "/complaintDashboard") return 5;
            if (CustomViewLink === "/slaDashboard") return 6;
            if (CustomViewLink === "/attendanceDashboard") return 4;
            return null;
        };

        if (DefaultDashboardType === 'Default') {
            if (dashboardId && dashboardCategoryId !== 1) {
                navigate(`/powerbi-dashboard/${dashboardId}`, {
                    state: { viewType: linkType?.toLowerCase() },
                });
            } else if (dashboardCategoryId === 1 && dashboardLink) {
                window.location.href = dashboardLink;
            } else {
                navigate('/');
            }
        } else {
            if (CustomViewLink) {
                const moduleID = getModuleID();
                // Dispatch first, then navigate when data is loaded in your dashboard component
                dispatch(loadCustomviews(null, signInType, signInId, moduleID));
                navigate(CustomViewLink, { state: { selectedDashboardID: signInDetails?.[0]?.CustomViewID } });
            }
        }
    };

    useEffect(() => {
        checkPosition();
        // Run once after mount

        // Optional: run on resize/scroll
        // window.addEventListener("resize", checkPosition);
        // window.addEventListener("scroll", checkPosition);
        // return () => {
        //     window.removeEventListener("resize", checkPosition);
        //     window.removeEventListener("scroll", checkPosition);
        // };
    }, []);

    const checkPosition = (id) => {

        // // alert('hi')
        // if (divRef.current) {
        //     const rect = divRef.current.getBoundingClientRect();
        //     const windowHeight = window.innerHeight;
        //     // Define "near top" and "near bottom" thresholds
        //     if (rect.top < 100) {
        //         console.log(rect.top, 'rect.top')
        //         console.log(windowHeight, 'windowHeight')
        //         // setPosition("near top");
        //     } else if (windowHeight - rect.bottom < 100) {
        //         // setPosition("near bottom");
        //         console.log(rect.top, 'near bottom')
        //         console.log(windowHeight, 'windowHeight')
        //     } else {
        //         // setPosition("middle");
        //         console.log(rect.top, 'middle')
        //         console.log(windowHeight, 'windowHeight')
        //     }
        // }

        // This will be called after the component has been 
        const element = liRef.current[id];
        // console.log(id, 'element')
        if (sideBarRef.current && element) {
            const sideBarRect = sideBarRef.current.getBoundingClientRect();
            const liRect = element.getBoundingClientRect();

            // Get the height and position of the li element relative to the parent div
            const liPositionTop = liRect.top - sideBarRect.top; // Position relative to parent div
            const liHeight = liRect.height;

            // console.log(`LI Element Top Position: ${liPositionTop}px`);
            // console.log(`sideBarRect.top;: ${liRect.top}px`);
            // console.log(`LI Element Height: ${liHeight}px`);
            console.log(` divRef.current: `, divRef.current);

            // Example of checking if it's near the top or bottom of the parent
            const sideBarHeight = sideBarRect.height;
            console.log(`sideBarHeight.;: ${sideBarHeight - liPositionTop - liHeight}px`);
            if (liPositionTop < 100) {
                console.log("LI Element is near the top of the sidebar");
                if (divRef.current) {
                    divRef.current.style.top = `${liRect.top}px`;
                    // divRef.current.style.bottom = '';
                }
            } else if (sideBarHeight - liPositionTop - liHeight < 600 && sideBarHeight - liPositionTop - liHeight > 201) {
                console.log("LI Element is near the bottom of the sidebar");
                if (divRef.current) {
                    divRef.current.style.top = `${liRect.top}px`;
                    // divRef.current.style.bottom = '';
                }
            } else if (sideBarHeight - liPositionTop - liHeight < 200) {
                console.log("LI Element is in the middle");
                if (divRef.current) {
                    divRef.current.style.top = `${liRect.top - sideBarRect.top - 180}px`;
                    // divRef.current.style.bottom = `${liRect.top}px`;
                }
            }
        }
    };

    return (
        < >
            {/* Left Icon Bar */}
            <div className="sidebar-first-div">
                <div className="sidebar-first-div-icons">
                    <img
                        src={companySmallLogo}
                        alt="Logo"
                        onClick={() => handleSidebarIconClick(null)}
                        className="company-small-logo"
                        style={{ cursor: "pointer" }}
                    />
                    {/* {modulePermissions.map((menu) => (
                        <img
                            key={menu.SideBarMenuID}
                            src={menu.SideBarMenuIcon}
                            alt={menu.SideBarMenuName}
                            onClick={() => handleSidebarIconClick(menu.SideBarMenuID)}
                            className="company-small-logo"
                            style={{ cursor: "pointer" }}
                        />
                    ))} */}
                    {modulePermissions.map((menu) => (
                        <div
                            key={menu.SideBarMenuID}
                            className={`sidebar-icon-wrapper ${selectedSidebarMenuId === menu.SideBarMenuID ? "active-sidebar-icon" : ""}`}
                            onClick={() => handleSidebarIconClick(menu.SideBarMenuID)}
                            style={{ cursor: "pointer" }}
                        >
                            <img
                                src={menu.SideBarMenuIcon}
                                alt={menu.SideBarMenuName}
                            // className="company-small-logo"
                            />
                        </div>
                    ))}

                </div>
            </div>

            {/* Expandable Sidebar Content */}
            <div
                className={`lm-sidevar ${click ? "clicked" : ""}`}
                ref={sideBarRef}
            >
                <div
                    className={`container ${click ? "clicked" : ""}`}
                // style={{ width: click ? "19.5vw" : "6vw" }}
                >
                    <button className={`button ${click ? "clicked" : ""}`} onClick={handleToggleSidebar}>
                        <img src={click ? closeIcon : openIcon} alt="toggle-menu" />
                    </button>

                    <div className="submenu-bar">
                        <img
                            src={companyLogo}
                            alt="Company Logo"
                            className={`company-logo ${click ? "clicked" : ""}`}
                        />
                        <div
                        // style={{ height: '80%', overflow: 'auto' }}
                        // className="sidebar-container"
                        >
                            <ul className={`slick-bar ${click ? "clicked" : ""}`}>
                                {(selectedSidebarMenuId
                                    ? modulePermissions.filter(menu => menu.SideBarMenuID === selectedSidebarMenuId)
                                    : modulePermissions
                                ).flatMap(menu =>
                                    menu.MainModules
                                        .filter(mainModule =>
                                            selectedSidebarMenuId ? true : mainModule.MainModuleName === "Dashboard"
                                        )
                                        .map((mainModule) => (
                                            <React.Fragment>
                                                <React.Fragment key={mainModule.MainModuleID}>
                                                    {mainModule.MainModuleName === "Dashboard" ? (
                                                        <li
                                                            ref={(el) => liRef.current[mainModule.MainModuleID] = el}
                                                            className={`item ${activeMenu === mainModule.MainModuleUrl ? "clicked" : ""}`}
                                                            onClick={handleDashboardClick}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <img src={mainModule.MainModuleIcon} alt="Dashboard" />
                                                            <span className={`text ${click ? "clicked" : ""}`}>
                                                                {mainModule.MainModuleName}
                                                            </span>
                                                        </li>
                                                    ) : (
                                                        <li
                                                            className={`item ${activeMenu === mainModule.MainModuleUrl ? "clicked" : ""}`}
                                                            // onClick={() => {
                                                            //     if (mainModule.MainModuleUrl) {
                                                            //         handleNavigation(mainModule.MainModuleUrl, mainModule.MainModuleID);
                                                            //     } else if (
                                                            //         mainModule.HasSubModules &&
                                                            //         Array.isArray(mainModule.SubModules) &&
                                                            //         mainModule.SubModules.length > 0
                                                            //     ) {
                                                            //         handleSubMenuToggle(mainModule.MainModuleID);
                                                            //     }
                                                            // }}
                                                            onClick={() => {
                                                                if (mainModule.MainModuleUrl) {
                                                                    // Find submodule matching activeMenu or fallback to first submodule with URL
                                                                    let subModuleToUse = mainModule.SubModules.find(sub => sub.ModuleUrl === mainModule.MainModuleUrl);

                                                                    if (!subModuleToUse) {
                                                                        // fallback to first submodule with a URL
                                                                        subModuleToUse = mainModule.SubModules.find(sub => sub.ModuleUrl);
                                                                    }

                                                                    if (subModuleToUse) {
                                                                        handleNavigation(mainModule.MainModuleUrl, subModuleToUse.ModuleID);
                                                                    } else {
                                                                        // fallback if no submodules with URL found
                                                                        handleNavigation(mainModule.MainModuleUrl, mainModule.MainModuleID);
                                                                    }

                                                                } else if (
                                                                    mainModule.HasSubModules &&
                                                                    Array.isArray(mainModule.SubModules) &&
                                                                    mainModule.SubModules.length > 0
                                                                ) {
                                                                    // Just toggle submenu if no URL
                                                                    handleSubMenuToggle(mainModule.MainModuleID);
                                                                }
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                            ref={(el) => liRef.current[mainModule.MainModuleID] = el}
                                                        >
                                                            <img
                                                                src={mainModule.MainModuleIcon || serviceLevelAgreement}
                                                                alt={mainModule.MainModuleName}
                                                            />
                                                            <span className={`text ${click ? "clicked" : ""}`}>
                                                                {mainModule.MainModuleName}
                                                            </span>
                                                            {mainModule.HasSubModules &&
                                                                Array.isArray(mainModule.SubModules) &&
                                                                mainModule.SubModules.length > 0 && (
                                                                    <img
                                                                        src={chevronDownImg}
                                                                        alt="toggle-submenu"
                                                                        className={
                                                                            openSubMenus[mainModule.MainModuleID]
                                                                                ? "sidebar-chevron-down"
                                                                                : "sidebar-chevron-right"
                                                                        }
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleSubMenuToggle(mainModule.MainModuleID);
                                                                        }}
                                                                        style={{ cursor: "pointer" }}
                                                                    />
                                                                )}
                                                        </li>
                                                    )}
                                                    {mainModule.HasSubModules &&
                                                        Array.isArray(mainModule.SubModules) &&
                                                        openSubMenus[mainModule.MainModuleID] && (
                                                            <ul className="sub-menu" ref={divRef}>
                                                                {mainModule.SubModules.map((sub) => (
                                                                    <li
                                                                        key={sub.ModuleID}
                                                                        className={`sub-item pt-2 pb-2 ${activeMenu === sub.ModuleUrl ? "clicked" : ""}`}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleNavigation(sub.ModuleUrl, sub.ModuleID);
                                                                        }}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        <img
                                                                            src={sub.ModuleIcon || serviceLevelAgreement}
                                                                            alt={sub.ModuleName}
                                                                        />
                                                                        <span className={`text ${click ? "clicked" : ""}`}>
                                                                            {sub.ModuleName}
                                                                        </span>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        )}
                                                </React.Fragment>
                                            </React.Fragment>
                                        ))
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </ >
    );
}



